var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "29", height: "29", viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.17 22.878A13.563 13.563 0 0 0 20.192 2.19 13.562 13.562 0 0 0 2.875 7.51V2.875H.937v6.781l.97.969h6.78V8.687h-4.24a11.64 11.64 0 1 1-.262 11.18l-1.719.895a13.562 13.562 0 0 0 22.704 2.116zm-6.512-1.88l1.372-1.37-5.53-5.531V6.75h-1.938v7.75l.283.686 5.813 5.812z", fill: "#727272" })
  );
});